import {ReactElement, ReactNode} from 'react';
import {Box, Paper, Typography} from '@mui/material';

type Props = {
  title?: string;
  action?: ReactNode;
  compact?: boolean;
  titleSize?: number | {xs?: number; sm?: number; md?: number};
  children: ReactNode;
};

export default function SectionCard({
  title,
  action,
  compact,
  titleSize,
  children
}: Props): ReactElement {
  return (
    <Paper
      elevation={0}
      sx={{
        p: compact ? {xs: 1, sm: 2, md: 3} : {xs: 2, md: 3},
        borderRadius: '12px',
        height: '100%',
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      {(title || action) && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 2,
            mb: compact ? 1.5 : 3
          }}
        >
          {title && (
            <Typography
              sx={{
                fontSize: titleSize ?? (compact ? 18 : 24),
                fontWeight: compact ? 500 : 400,
                lineHeight: compact ? 1.5 : 1.334,
                letterSpacing: compact ? '0.15px' : undefined,
                color: 'ctaDark'
              }}
            >
              {title}
            </Typography>
          )}
          {action}
        </Box>
      )}
      {children}
    </Paper>
  );
}
